function renderTurnProgress() {
  const turnElement = document.querySelector(
    ".taydu2_cuuthienhuyennu_header .gr_luot .turn",
  );

  const progressBar = document.querySelector(
    ".taydu2_cuuthienhuyennu_header .gr_bar--progress",
  );

  if (turnElement) {
    const turn = parseInt(turnElement.textContent, 10);

    if (!isNaN(turn)) {
      const maxTurn = 50000;
      const percent = Math.min((turn / maxTurn) * 100, 100);
      if (progressBar) progressBar.style.width = percent + "%";

      document
        .querySelectorAll(".taydu2_cuuthienhuyennu_header .gr_reward--item")
        .forEach(function (item) {
          const milestone = parseInt(item.dataset.milestone, 10);
          if (!isNaN(milestone) && turn >= milestone) {
            item.classList.add("active");
          }
        });
    }
  }
}

window.renderTurnProgress = renderTurnProgress;

window.addEventListener("load", function () {
  if ($(window).width() > 999 && $("video").length > 0) {
    const video = document.getElementsByTagName("video")[0];
    const sources = video.getElementsByTagName("source");
    console.log(sources);
    const linkmp4 = $(sources).data("src");
    sources[0].src = linkmp4;
    video.load();
  }

  renderTurnProgress();
});
